export default __webpack_public_path__ + "static/media/0@3x.fbd38a22.png";